import "./TheBigDay.module.css";
import Header from "@/reusable_sections/Header";
import CeremonyReception from "./sections/CeremonyReception";
import TheVenueLocation from "./sections/TheVenueLocation";
import OurServices from "./sections/OurServices";
import PhotosGallery from "./sections/PhotosGallery";
import Footer from "@/reusable_sections/Footer";
export default function TheBigDayPage() {
  return <div>
      <Header />
      <CeremonyReception />
      <OurServices />
      <PhotosGallery />
      <Footer />
    </div>;
}